module.exports = __webpack_public_path__ + "img/pr-1.24a5d797.png";